import './card-section-more-style.scss'

import { Link } from 'gatsby'
import React from 'react'

import { ReactComponent as ChevronIcon } from '@/assets/icons/crypto_general_icons_chevron-down_clean.svg'

const CardSectionMore = ({ title, i18n, category }) => {
  const url = i18n.language.startsWith('en')
    ? `/${category}`
    : `/${category}/${i18n.language.toLowerCase()}`

  return (
    <div className="card-section-more">
      <Link to={url}>
        <ChevronIcon className="icon-card-section-more" />
        <p>{title}</p>
      </Link>
    </div>
  )
}

export default CardSectionMore
